"use strict";

import angular from "angular";
import { formatHours, HOURS_UNIT } from "../../utils/format-hours";

/**
 * `{{ valor | formatHours }}` — horas decimais em `H:MM` (1.5 → "1:30").
 *
 * Também registrado com o nome da unidade (`hours`): projeção, orçamento e os relatórios deles
 * formatam com `$filter(serie.unit)`, e sem um filtro `hours` o injector falhava e a célula
 * ficava vazia. Os argumentos extras desses chamadores (casas decimais) não se aplicam a horas.
 */
const name = "formatHours";
const factory = function formatHoursFilter() {
    return function (input) {
        return formatHours(input);
    };
};
angular.module("nucont.shared").filter(name, factory);
angular.module("nucont.shared").filter(HOURS_UNIT, factory);
export default { name, factory };
